<template>
    <div class="OnlineService">
        <div class="part" @click="goonline('在线客服', '1')">
            <a target="_blank">
                <i class="icon iconfont icon-zaixiankefu"></i>
                <p class="gotop">在线客服</p>
            </a>
        </div>
        <!-- <div class="part">
            <a target="_blank"
               href="https://www.yimidida.com/help/tsjy.jsp">
                <i class="icon iconfont icon-tousujianyi"></i>
                <p class="gotop">投诉建议</p>
            </a>
        </div> -->
        <div class="part WeChat">
            <i class="icon iconfont icon-weixin"></i>
            <p>关注我们</p>
            <div class="chat">
                <div class="bann">
                    <img src="@/assets/images/erweima.png" />
                    <p style="margin-top: 5px;">壹米滴答公众号</p>
                    <!--<span>最新动态 实时掌握</span>-->
                </div>
                <div class="bann">
                    <img src="@/assets/images/yimididatoutiao.png" />
                    <p style="margin-top: 5px;">壹米滴答视频号</p>
                    <!--<span>赋能高效 创收共赢</span>-->
                </div>
            </div>
        </div>
        <!-- <div class="part"
             @click="setcookies('返回旧版','1')">
            <a target="_self">
                <i class="icon iconfont icon-fanhuijiuban"></i>
                <p>返回旧版</p>
            </a>
        </div> -->
        <div class="part" @click="gotop()">
            <i class="icon iconfont icon-huidaodingbu"></i>
            <p class="gotop">返回顶部</p>
        </div>
    </div>
</template>

<script>
import Cookies from "js-cookie";
import { menuqueryaddressid } from "@/api/apiall";
import { getUserInfo } from "@/api/homePage";
export default {
    data() {
        return {
            scrollTop: 0,
            time: 0,
            dParams: 20,
            scrollState: 0,
            logininfo: ""
        };
    },
    mounted() {
        window.addEventListener("scroll", this.getScrollTop);
        this.getUse();
    },
    watch: {
        //监听路由变化
        $route() {
            this.getUse();
        }
    },
    methods: {
        getUse() {
            let MenuQueryDto = { name: "用户接口", sign: "1" };
            menuqueryaddressid(MenuQueryDto).then(res => {
                if (res.status === 2000) {
                    getUserInfo(res.data.routAddress).then(res => {
                        if (res.status == 2000) {
                            let result = res.data.data;
                            this.logininfo = result;
                        } else {
                            // console.log(res.data);
                        }
                    });
                }
            });
        },
        // if (checkIE()) {
        //     window.addEventListener(
        //         "hashchange",
        //         () => {
        //             var currentPath = window.location.hash.slice(1);
        //             if (this.$route.path !== currentPath) {
        //                 this.$router.push(currentPath);
        //             }
        //         },
        //         false
        //     );
        // }
        setcookies(item, num) {
            var win = window.open("", "_blank");
            menuqueryaddressid({ sign: num, name: item })
                .then(res => {
                    if (res.status === 2000) {
                        this.path = res.data.demoFlag;
                        this.pathid = res.data.id;
                        // this.$router.push({
                        //     path: this.path,
                        //     query: {
                        //         id: this.pathid
                        //     }
                        // });
                        //window.open(res.data.routAddress, "_blank");
                        win.location = res.data.routAddress;
                    }
                })
                .catch(err => {});
        },
        goonline(item, num) {
            let islogin = sessionStorage.getItem("userInfoView");
            if (islogin == null) {
                sessionStorage.setItem("activeIndex", item.id);
                window.open(
                    "/usercenter/login?successUrl=https%3A%2F%2Fwww.yimidida.com",
                    "_self"
                );
                return;
            }
            var win = window.open("", "_blank");
            menuqueryaddressid({ sign: num, name: item })
                .then(res => {
                    if (res.status === 2000) {
                        this.path = res.data.demoFlag;
                        this.pathid = res.data.id;
                        // this.$router.push({
                        //     path: this.path,
                        //     query: {
                        //         id: this.pathid
                        //     }
                        // });
                        if (this.logininfo !== "") {
                            win.location =
                                res.data.routAddress +
                                "?openId=" +
                                this.logininfo.userCode +
                                "&nickname=" +
                                this.logininfo.nickname +
                                "&gender=" +
                                this.logininfo.sex;
                        } else {
                            win.location = res.data.routAddress;
                        }
                        //    this.$store.dispatch("UpdateActive", res.data);
                        // window.open(res.data.routAddress, "_blank");
                    }
                })
                .catch(err => {});
        },

        // setcookies() {
        //     // this.$cookies.set("websit", "oldwebsit");
        //     Cookies.set("websit", "oldwebsit");
        //     // location.reload();
        //     // window.open("http://wwwtest.yimidida.com/home/home.jsp", "_blank");
        //     // location.reload();
        //     let a = document.createElement("a");
        //     a.target = "_self";
        //     a.href =
        //         "https://www.yimidida.com/home/home.jsp?v=" + Math.random(10);
        //     a.click();
        // },
        gotop() {
            if (!!window.ActiveXObject || "ActiveXObject" in window) {
                document.documentElement.scrollTop = 0;
            } else {
                this.toTop();
            }
        },
        toTop() {
            this.scrollState = 1;
            // e.preventDefault();
            let _this = this;
            this.time = setInterval(function() {
                _this.gotoTop(_this.scrollTop - _this.dParams);
            }, 10);
        },
        gotoTop(distance) {
            this.dParams += 20;
            if (distance > 0) {
                distance = distance;
            } else {
                distance = 0;
            }
            document.documentElement.scrollTop = document.body.scrollTop = window.pageYOffset = distance;
            if (this.scrollTop < 10) {
                clearInterval(this.time);
                this.dParams = 20;
                this.scrollState = 0;
            }
        },
        getScrollTop() {
            this.scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
        }
    }
};
</script>

<style scoped lang="scss">
.OnlineService {
    position: fixed;
    right: 0;
    bottom: 100px;
    z-index: 6;
    color: aliceblue;
    .online {
        margin-bottom: 100px;
        color: #fabe00;
        i {
            font-size: 56px;
            cursor: pointer;
        }
    }
    .part {
        cursor: pointer;
        width: 64px;
        height: 86px;
        background-color: #fabe00;
        text-align: center;
        // box-shadow: 5px 2px 1px #9c8989;
        a {
            color: #fff;
        }
        .icon {
            font-size: 26px;
            // margin-top: 16px;
            position: relative;
            top: 18px;
        }
        .icon-weiboheibai {
            font-size: 28px;
        }
        .icon-weixin {
            font-size: 28px;
        }
        .icon-huidaodingbu {
            font-size: 24px;
        }
        p {
            font-size: 12px;
            position: relative;
            top: 20px;
        }
    }
    .part:hover {
        background-color: #d2a124;
    }
    .part:nth-child(1):after {
        content: " ";
        display: block;
        width: 50px;
        height: 1px;
        position: relative;
        top: 39px;
        margin: auto;
        z-index: 10;
        background-color: rgba(255, 255, 255, 0.5);
    }
    .part:nth-child(2):after {
        content: " ";
        display: block;
        width: 50px;
        height: 1px;
        position: relative;
        top: 41px;
        margin: auto;
        z-index: 10;
        background-color: rgba(255, 255, 255, 0.5);
    }
    .part:nth-child(3):after {
        content: " ";
        display: block;
        width: 50px;
        height: 1px;
        position: relative;
        top: 43px;
        margin: auto;
        z-index: 10;
        background-color: rgba(255, 255, 255, 0.5);
    }
    // .part:nth-child(4):after {
    //     content: " ";
    //     display: block;
    //     width: 50px;
    //     height: 1px;
    //     position: relative;
    //     top: 42px;
    //     margin: auto;
    //     z-index: 10;
    //     background-color: rgba(255, 255, 255, 0.5);
    // }
    .chat {
        position: absolute;
        right: 64px;
        top: 50px;
        width: 240px;
        height: 154px;
        background-color: #fff;
        display: none;
        .bann {
            width: 120px;
            float: left;
            // position: relative;
            img {
                // margin-left: 6px;
                width: 120px;
            }
            p {
                color: #000;
                font-size: 15px;
                // margin-left: 7px;
                text-align: center;
                position: relative;
                top: -8px;
            }
            span {
                text-align: center;
                color: #000;
                font-size: 10px;
                position: relative;
                top: -8px;
            }
        }
    }
    .WeChat:hover .chat {
        display: block;
    }
    .gotop {
        margin-top: 5px;
    }
}
</style>
